import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { ProductVariantResponse, SearchHistory } from "../../models";
import { HttpService } from "./http.service";
import { searchHistory } from "@sgm-frontend/core";

@Injectable({
  providedIn: 'root'
})
export class SearchHistoryService extends HttpService<string|searchHistory, SearchHistory> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'search-history');
  }

  

  getProductVarientHistory(): Observable<SearchHistory[]> {
    return this.getAll( 'me') as unknown as Observable<SearchHistory[]>;
  }
   getProductVarientHistoryTrending(): Observable<SearchHistory[]> {
    return this.getAll( 'trending') as unknown as Observable<SearchHistory[]>;
  }
   postProductSearchHistory(history:searchHistory): Observable<SearchHistory[]> {
    return this.create(history,'me') as unknown as Observable<SearchHistory[]>;
  }
  
}